import { cycloneApiClient } from '@/shared/api/core/axios-instance';

import { getDagDashboardListMock } from '@/entities/dag/api/_internal/dagMockStore';
import { shouldUseDagMockApi } from '@/entities/dag/api/_internal/shouldUseDagMockApi';
import type { DagDashboardListParams, DagDashboardListResponse } from '@/entities/dag/domain/types';

/** 빈 문자열·공백만 있는 값은 쿼리에서 제외해 `keyword=` 형태가 붙지 않게 한다. */
const trimToQueryString = (value: string | undefined): string | undefined => {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
};

export const fetchDagDashboardListApi = async (params?: DagDashboardListParams): Promise<DagDashboardListResponse> => {
  if (shouldUseDagMockApi()) {
    return getDagDashboardListMock(params);
  }

  const response = await cycloneApiClient.get<DagDashboardListResponse>('/dags/', {
    params: {
      keyword: trimToQueryString(params?.keyword),
      offset: params?.offset ?? undefined,
      limit: params?.limit ?? undefined,
      status: params?.status ?? undefined,
      maturity: trimToQueryString(params?.maturity),
      is_bookmarked: params?.isBookmarked ?? undefined,
      tag: trimToQueryString(params?.tag),
      sort_by: params?.sortBy ?? undefined,
      sort_order: params?.sortOrder ?? undefined,
    },
  });

  return response.data;
};
